export default "__VITE_ASSET__11e67403__"